import { useNavigate, useOutletContext } from "react-router-dom";

import ExperienceIndexResultsTab from "../_ExperienceIndexResultsTab";
import type { CareerProfileQueryResult } from "../_useCareerProfileQuery";
import { getExperienceIndexCompletion, getExperienceIndexHubState } from "../careerPlanHubSummaries";
import { careerProfileExperienceIndexAssessmentHref } from "../careerPlanLatest";
import { firstLiveCatalogCompetencyId } from "../experienceIndexAnswers";

export default function CareerProfileExperienceIndexPage() {
  const navigate = useNavigate();
  const { pgaId, assessment, competencies, roleRubrics, canManageCareerPlan } =
    useOutletContext<CareerProfileQueryResult>();

  if (!pgaId) return null;

  const completion = getExperienceIndexCompletion(assessment);
  const assessmentComplete = completion.total > 0 && completion.remaining === 0;
  const neverStarted = getExperienceIndexHubState(completion) === "never_started";
  const startCompetencyId =
    neverStarted && canManageCareerPlan ? firstLiveCatalogCompetencyId(competencies) : undefined;

  return (
    <ExperienceIndexResultsTab
      assessmentComplete={assessmentComplete}
      assessmentComparisonRole={assessment?.assessmentComparisonRole}
      scores={assessment?.scores ?? []}
      rubrics={roleRubrics}
      neverStarted={neverStarted}
      onSelectCompetency={(competencyId) => navigate(careerProfileExperienceIndexAssessmentHref(pgaId, competencyId))}
      onStart={
        startCompetencyId
          ? () =>
              navigate(careerProfileExperienceIndexAssessmentHref(pgaId, startCompetencyId), {
                state: { startExperienceIndexEditing: true }
              })
          : undefined
      }
    />
  );
}
